import $ from 'jquery'

// eslint-disable-next-line no-undef
const i18n = bookingHub

const initPdfButtons = (wrapperEL) => {
  return new Promise((resolve, reject) => {
    if (!wrapperEL) {
      reject()
    }

    const pdfButtons = wrapperEL.querySelectorAll('[data-bhub-pdf-button]')

    if (pdfButtons.length) {
      pdfButtons.forEach((pdfButton) => {
        pdfButton.addEventListener('click', (e) => {
          e.preventDefault()

          const bookingId = pdfButton.getAttribute('data-booking-db-id')
          // const pdfTitle = pdfButton.getAttribute('data-pdf-title')

          $.ajax({
            url: i18n.ajaxUrl,
            method: 'POST',
            xhrFields: {
              responseType: 'blob',
            },
            data: {
              action: 'bhub/pdf/generate',
              _ajax_nonce: i18n.nonce,
              bookingId,
            },
            success: (data) => {
              const button = document.createElement('a')
              const blob = new Blob([data], { type: 'application/pdf' })

              button.href = URL.createObjectURL(blob)
              // button.download = pdfTitle
              button.target = '_blank'
              button.click()
              button.remove()
              resolve()
            },
          })
        })
      })
    }
  })
}

export default initPdfButtons
